export default __webpack_public_path__ + "static/media/whiteSpiral.6b1b8530.png";